import { useEffect } from 'react';
import { HubCarouselSection } from '@/components/Hub/HubCarouselSection';
import type { HubSection } from '@/components/Hub/hubSectionTypes';

export interface HubSectionSlotProps {
    section: HubSection;
    /** Lets the panel show its empty message once every section has reported nothing. */
    onHasContentChange?: (id: string, hasContent: boolean) => void;
}

// Calls the hook first and decides emptiness after, which is the point of the component.
// Skipping an empty section's hook instead would change hook order between renders.
export const HubSectionSlot = ({ section, onHasContentChange }: HubSectionSlotProps) => {
    const data = section.useData();
    const hasContent = data.isLoading || (!data.isError && data.slides.length > 0);

    useEffect(() => {
        onHasContentChange?.(section.id, hasContent);
    }, [section.id, hasContent, onHasContentChange]);

    if (!hasContent) {
        return null;
    }

    return <HubCarouselSection section={section} data={data} />;
};
